import { dateFormatter2 } from "../Wrapper/CommonFun";


export const REPORTSERVERTIME = {
  "Delivery Content": 0.0104,
  "Batch Summary": 0.0553,
  "Delivery Advance": 0.457,
  "Batch Aborted": 0.0553,
  Aggregator: 0.3724,
  "Delivery Summary": 9.423,
  "Performance Route": 0.8645,
  "Performance User": 0.123,
  Schedule: 0.08,
};


export const sizesArray = ["B", "kB", "MB", "GB", "TB", "PB"];


export const tableCustomStyles = (config) => {
  let { height, minHeight, maxHeight, overflow, fontSize, headFontSize } =
    config ?? {};
  let { tableStyle, wrapperStyle } = config ?? {};

  return {
    table: {
      style: {
        height: height ?? `calc(100vh - 310px)`,
        minHeight: minHeight ?? 400,
        ...(maxHeight ? { maxHeight } : {}),
        overflow: overflow ?? `hidden auto`,
        ...(tableStyle ?? {}),
      },
    },
    tableWrapper: {
      style: {
        height: height ?? `calc(100vh - 310px)`,
        minHeight: minHeight ?? 400,
        ...(maxHeight ? { maxHeight } : {}),
        overflow: overflow ?? `auto`,
        ...(wrapperStyle ?? {}),
      },
    },
    progress: {
      style: {
        backgroundColor: "transparent",
      },
    },
    headCells: {
      style: {
        fontSize: `${headFontSize ?? 14}px`,
      },
    },
    cells: {
      style: {
        fontSize: `${fontSize ?? 12}px`,
      },
    },
  };
};


export const getDatesFromDay = (day) => {
  let eDate = new Date();
  let sDate = new Date();
  const dayCount = +day === 30 || +day === 31 ? 31 : +day;

  if (dayCount > 1) {
    sDate.setDate(sDate.getDate() - dayCount + 1);
  } else if (dayCount === 1) {
    sDate.setDate(sDate.getDate() - 1);
    eDate.setDate(eDate.getDate() - 1);
  }

  return {
    startDate: dateFormatter2(sDate).split(" ")[0],
    endDate: dateFormatter2(eDate).split(" ")[0],
  };
};


export const getValidSelectedIds = (
  selectedRows,
  userListDataOrSearchVal = "",
  searchVal = ""
) => {
  const userListData =
    userListDataOrSearchVal &&
    typeof userListDataOrSearchVal === "object" &&
    !Array.isArray(userListDataOrSearchVal)
      ? userListDataOrSearchVal
      : null;
  const effectiveSearchVal =
    typeof userListDataOrSearchVal === "string"
      ? userListDataOrSearchVal
      : searchVal;

  if (!selectedRows) {
    return { ids: [], isAllSelected: false, isSearchMode: false };
  }

  if (selectedRows._searchSelected === true) {
    const searchIds = selectedRows._selectedIds || [];
    return {
      ids: searchIds,
      isAllSelected: false,
      isSearchMode: true,
      searchTerm: selectedRows._searchTerm,
    };
  }

  if (selectedRows._allSelected === true && !selectedRows._isSearchMode) {
    return {
      ids: "ALL",
      isAllSelected: true,
      isSearchMode: false,
    };
  }

  if (selectedRows?.all === true && !selectedRows?.allInSearch) {
    return {
      ids: "ALL",
      isAllSelected: true,
      isSearchMode: false,
    };
  }

  if (selectedRows?.allInSearch === true) {
    const searchIds =
      userListData?.data?.map((row) => row?.id).filter(Boolean) || [];
    return {
      ids: searchIds,
      isAllSelected: false,
      isSearchMode: true,
      searchTerm: effectiveSearchVal || undefined,
    };
  }

  if (Array.isArray(selectedRows)) {
    const validIds = selectedRows
      .filter((id) => {
        const isValid =
          id !== null && id !== undefined && id !== "" && !isNaN(Number(id));
        if (!isValid) {
          console.warn("⚠️ Invalid ID filtered out:", id);
        }
        return isValid;
      })
      .map((id) => Number(id));

    return {
      ids: validIds,
      isAllSelected: false,
      isSearchMode: false,
    };
  }

  console.warn(
    "❌ Unexpected selectedRows format:",
    typeof selectedRows,
    selectedRows
  );
  return { ids: [], isAllSelected: false, isSearchMode: false };
};
export const statusMap = {
  PENDING: "PENDING",
  QUEUED: "QUEUED",
  Q: "QUEUED",
  ATES: "ATES",
  CAAS: "CAAS",
  C: "CAAS",
  HLR: "HLR",
  H: "HLR",
  DELIVRD: "DELIVRD",
  UNDELIV: "UNDELIV",
  REJECTED: "REJECTED",
  RJ: "REJECTED",
  ACCEPTD: "ACCEPTD",
  ERROR: "ERROR",
  BLOCKED: "BLOCKED",
  UN_PROCESSED: "UN_PROCESSED",
  UN: "UN_PROCESSED",
  ZERO_COST: "ZERO_COST",
  EXPIRED: "EXPIRED",
  NR: "NON RESPOND",
  ERR_RESPOND: "ERR_RESPOND",
  MINCOST: "MINCOST",
  M: "MINCOST"
};
